import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-compact',
  templateUrl: './icon-compact.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCompactComponent {}
